import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { IoMdTrash } from 'react-icons/io';

const DeleteAccountModal = ({ onConfirm }) => {
  const reasons = [
    {
      id: 'difficult',
      label: 'Problèmes avec le scan',
    },
    {
      id: 'stores',
      label: 'Suppressions de la carte bleue',
    },
    {
      id: 'tech',
      label: 'Long à charger',
    },
    {
      id: 'alternative',
      label: 'Moyen de paiement indisponible',
    },
    {
      id: 'privacy',
      label: 'Inquiétudes concernant la confidentialité',
    },
    {
      id: 'other',
      label: 'Autre raison',
      subtext: 'Merci de nous en dire plus',
    },
  ];

  const showDeleteConfirmation = async () => {
    // Première étape : Sélection de la raison
    const { value: reasonResult, dismiss } = await Swal.fire({
      title: 'Nous sommes désolés de te voir partir',
      html: `
        <div class="text-left mb-4">
          <p class="mb-3">Peux tu nous dire pourquoi vous souhaitez supprimer ton compte ?</p>
          <p class="text-sm text-gray-500 mb-4">ton retour nous aide à améliorer notre service</p>
          <div class="space-y-3">
            ${reasons
              .map(
                (reason) => `
              <div class="flex items-center p-3 border rounded hover:bg-gray-50 cursor-pointer reason-option" data-id="${reason.id}" data-label="${reason.label}">
                <div>
                  <p class="font-medium">${reason.label}</p>
                  <p class="text-sm text-gray-500">${reason.subtext?.length > 0 ? reason.subtext : ''}</p>
                </div>
              </div>
            `,
              )
              .join('')}
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Continuer',
      cancelButtonText: 'Annuler',
      customClass: {
        confirmButton: 'delete-button',
        cancelButton: 'cancel-button',
      },
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      didOpen: () => {
        const options = document.querySelectorAll('.reason-option');
        let selectedOption = null;
        if (options) {
          options.forEach((option) => {
            option.addEventListener('click', () => {
              options.forEach((opt) =>
                opt.classList.remove(
                  '!border-red-500',
                  '!bg-red-50',
                  'reason-option-choice',
                ),
              );
              option.classList.add(
                '!border-red-500',
                '!bg-red-50',
                'reason-option-choice',
              );
              selectedOption = option.dataset.id;
              Swal.getConfirmButton().disabled = false;
            });
          });
        }
        Swal.getConfirmButton().disabled = true;
      },
    });

    if (dismiss) return;

    let details = null;
    let selectedReasonId = document.querySelector('.reason-option-choice')
      ?.dataset.id;
    let selectedReason = document.querySelector('.reason-option-choice')
      ?.dataset.label;

    // Deuxième étape : Détails supplémentaires uniquement si "other" est sélectionné
    if (selectedReasonId == 'other') {
      console.log('selectedReasonId', selectedReasonId);
      const detailsResult = await Swal.fire({
        title: 'Peux tu nous en dire plus ?',
        input: 'textarea',
        inputPlaceholder: 'ton retour nous aide à nous améliorer...',
        inputAttributes: {
          rows: 4,
        },
        showCancelButton: true,
        confirmButtonText: 'Continuer',
        cancelButtonText: 'Retour',
        customClass: {
          confirmButton: 'delete-button',
          cancelButton: 'cancel-button',
        },
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
      });

      if (detailsResult.dismiss) return;
      details = detailsResult.value;
    }

    // Étape finale : Confirmation de suppression
    const { value: confirmed } = await Swal.fire({
      title: 'Dernière étape',
      html: `
        <p class="text-red-500 mb-4">Cette action est irréversible. ton compte et toutes tes données seront définitivement supprimés.</p>
        <p class="mb-2">Pour confirmer, écris "SUPPRIMER" ci-dessous :</p>
        <input 
          type="text" 
          id="confirmInput" 
          style="font-family: 'geomanistmedium';"
          class="swal2-input" 
          placeholder="Tapez 'SUPPRIMER'"
          autocomplete="off"
        >
      `,
      showCancelButton: true,
      confirmButtonText: 'Supprimer',
      cancelButtonText: 'Annuler',
      customClass: {
        confirmButton: 'delete-button',
        cancelButton: 'cancel-button',
      },
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      showLoaderOnConfirm: true,
      preConfirm: () => {
        const value = document.getElementById('confirmInput').value;
        if (value != 'SUPPRIMER') {
          Swal.showValidationMessage('Ecris "SUPPRIMER" pour confirmer');
          return false;
        }
        return true;
      },
      didOpen: () => {
        const input = document.getElementById('confirmInput');
        const confirmButton = Swal.getConfirmButton();
        confirmButton.disabled = true;
        if (input) {
          input.addEventListener('input', (e) => {
            confirmButton.disabled = e.target.value !== 'SUPPRIMER';
          });
        }
      },
    });

    if (confirmed) {
      // Appeler la fonction de suppression avec la raison et les détails
      onConfirm(selectedReasonId, selectedReason, details);
      console.log(
        'Suppression du compte...',
        selectedReason,
        selectedReasonId,
        details,
      );
    }
  };

  return (
    <button
      type="button"
      className="delete-button"
      onClick={showDeleteConfirmation}
    >
      <span className="emoji">
        <IoMdTrash style={{ opacity: '0.4', fill: 'red' }} />
      </span>
      <span style={{ opacity: '0.4', color: 'red' }}>Supprimer mon compte</span>
    </button>
  );
};

export default DeleteAccountModal;
